import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class Search extends BaseClass {

    /**
     * Constructor
     * @param options
     */
    constructor(options)
    {
        super(options, defaultOptions);
    }

    /**
     * Sets sessions with data in main filter
     */
    setsearchfield(isReload)
    {
        var location = $('#searchlocation').val();
        var searchType = $("#searchtype").val();
        var typeId = $("#typeid").val();
        var searchStartDate = $('.t-main .t-input-check-in').val();
        var searchEndDate = $('.t-main .t-input-check-out').val();

        if (searchStartDate === "null") {
            searchStartDate = 0;
        }

        if (searchEndDate === "null") {
            searchEndDate = 0;
        }

        var searchRooms = [];

        $('[data-room-settings="main"]').each(function (index, item) {
            searchRooms[index] = {};
            searchRooms[index].adults = $(item).find('[data-field-name="searchadult"]').text();
            searchRooms[index].children = $(item).find('[data-field-name="searchchild"]').text();
            searchRooms[index].childrenages = $(item).find('option:selected').map(function () {
                return ($(this).val());
            }).get();
        });

        var data = {
            location: location,
            searchtype: searchType,
            typeid: typeId,
            searchstartdate: searchStartDate,
            searchenddate: searchEndDate,
            searchrooms: searchRooms,
            '_token': $('meta[name="csrf-token"]').attr('content')
        };

        var locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {'X-App-Locale': locale,},
            url: window.origin+'/change-search-record',
            method: 'post',
            data: data,
            success: function (returnData) {
                if (isReload == 1) {
                    window.location.reload(true);
                } else {
                    var allAdults = 0;
                    var allRooms = searchRooms.length;
                    var allChildren = 0;

                    for (var i = 0; i < allRooms; i++) {
                        allAdults += parseInt(searchRooms[i].adults);
                        allChildren += parseInt(searchRooms[i].children);
                    }

                    if (allAdults > 1) {
                        var stringAdult = ' '+ returnData['adults'] + ', ';
                    } else {
                        var stringAdult = ' '+ returnData['adult'] + ', ';
                    }

                    if (allRooms > 1) {
                        var stringRoom = ' '+ returnData['rooms'];
                    } else {
                        var stringRoom = ' '+ returnData['room'];
                    }

                    if (allChildren > 1 || allChildren == 0) {
                        var stringChildren = ' '+ returnData['children'];
                    } else if (allChildren === 1) {
                        var stringChildren = ' '+ returnData['child'];
                    }

                    let outputString = allRooms + stringRoom + ',' + allAdults + stringAdult + allChildren + stringChildren;
                    $('[data-rooms-settings-values]').html(outputString);
                }
            }
        });
    }

    /**
     * Sets sessions with data in hotel filter
     */
    setsearchhotelfield(parent)
    {
        parent = $(parent).first();
        let searchRooms = [];

        parent.find('.plus-minus-wrapper-details').each(function (index, item) {
            searchRooms[index] = {};
            searchRooms[index].adults = $(item).find('[data-field-name="avaladult"]').text();
            searchRooms[index].children = $(item).find('[data-field-name="avalchild"]').text();
            searchRooms[index].childrenages = $(item).find('option:selected').map(function () {
                return ($(this).val());
            }).get();
        });

        var data = {
            searchrooms: searchRooms,
            '_token': $('meta[name="csrf-token"]').attr('content')
        };

        var locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {'X-App-Locale': locale,},
            url: window.origin+'/change-search-record',
            method: 'post',
            data: data,
            success: function (returnData) {
                var allAdults = 0;
                var allRooms = searchRooms.length;
                var allChildren = 0;

                for (var i = 0; i < allRooms; i++) {
                    allAdults += parseInt(searchRooms[i].adults);
                    allChildren += parseInt(searchRooms[i].children);
                }

                if (allAdults === 1) {
                    var stringAdult = ' '+ returnData['adult'] + ', ';
                } else  if (allAdults === 2) {
                    var stringAdult = ' '+ returnData['adults_two'] + ', ';
                } else if(allAdults === 3 ) {
                    var stringAdult = ' '+ returnData['adults_three'] + ', ';
                } else if(allAdults === 4 ) {
                    var stringAdult = ' '+ returnData['adults_four'] + ', ';
                } else if (allAdults >= 5) {
                    var stringAdult = ' '+ returnData['adults'] + ', ';
                }

                if (allRooms === 1) {
                    var stringRoom = ' '+ returnData['room'] + ', ';
                } else  if (allRooms === 2) {
                    var stringRoom = ' '+ returnData['rooms_two'] + ', ';
                } else if(allRooms === 3 ) {
                    var stringRoom = ' '+ returnData['rooms_three'] + ', ';
                } else if(allRooms === 4 ) {
                    var stringRoom = ' '+ returnData['rooms_four'] + ', ';
                } else if (allRooms >= 5) {
                    var stringRoom = ' '+ returnData['rooms'] + ', ';
                }


                if (allChildren > 4 || allChildren == 0) {
                    var stringChildren = ' '+ returnData['children'];
                } else if (allChildren === 1) {
                    var stringChildren = ' '+ returnData['child'];
                } else {
                    var stringChildren = ' '+ returnData['children_two'];
                }


                if (allChildren === 1) {
                    var stringChildren = ' '+ returnData['child'];
                } else  if (allChildren === 2) {
                    var stringChildren = ' '+ returnData['children_two'];
                } else if(allChildren === 3 ) {
                    var stringChildren = ' '+ returnData['children_three'];
                } else if(allChildren === 4 ) {
                    var stringChildren = ' '+ returnData['children_four'];
                } else if (allChildren >= 5) {
                    var stringChildren = ' '+ returnData['children'];
                }

                let outputString = allRooms + stringRoom + allAdults + stringAdult + allChildren + stringChildren;
                $('[data-rooms-settings-values]').html(outputString);
            }
        });
    }

    /**
     * Function that sets session after clicking ong recently viewed module on homepage and redirects to masonry
     *
     * @param {Element} e clicked element
     */
    setSearchFieldRecentlyViewed(e)
    {
        let searchRooms = $(e).data('searchRooms');
        let startDate = $(e).data('startDate');
        let endDate = $(e).data('endDate');
        let location = $(e).data('location');
        let locale = $('meta[name="country"]').attr('content');

        let data = {
            location: location,
            searchstartdate: startDate,
            searchenddate: endDate,
            searchrooms: searchRooms,
            '_token': $('meta[name="csrf-token"]').attr('content')
        };

        $.ajax({
            headers: {
                'X-App-Locale': locale,
            },
            url: window.origin + '/change-search-record',
            method: 'post',
            data: data,
            success: function (data) {
                window.location.href = $(e).data('url');
            }
        });
    }
}
